import { FC, Key, useState } from "react";
import { CustomRouter } from "../../model/custom-router.model";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./navbar.css";
import ButtonUI from "../button/buttons";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
interface NavBarCustomProps {
  routers: CustomRouter[];
}

const NavBarCustom: FC<NavBarCustomProps> = ({ routers }) => {
  return (
    <nav className="menu">
      <ul className="options">
        {routers.map((option, index) => (
          <MenuItem key={index} option={option} />
        ))}
      </ul>
    </nav>
  );
};

const MenuItem: FC<{ option: CustomRouter }> = ({ option }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li className="option">
      <div className="menu-header">
        {option.to && (
          <NavLink
            to={option.to}
            className={({ isActive }) =>
              isActive ? "link link-active" : "link"
            }
          >
            {option.icon && (
              <FontAwesomeIcon icon={option.icon} className="icon" />
            )}
            <span className="text" >{option.text}</span>
            {option.children && option.children.length > 0 && (
              <button className="button-arrow" onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? <ArrowDropUpIcon /> :  <ArrowDropDownIcon />}
              </button>
            )}
          </NavLink>
        )}
        {option.click && (
          <button className="link" onClick={option.click}>
            {option.text}
          </button>
        )}
      </div>
      {option.children && option.children.length > 0 && isOpen && (
        <ul className="submenu">
          {option.children.map(
            (child: CustomRouter, childIndex: Key | null | undefined) => (
              <MenuItem key={childIndex} option={child} />
            )
          )}
        </ul>
      )}
    </li>
  );
};

export default NavBarCustom;
